import { render, staticRenderFns } from "./ruleItem.vue?vue&type=template&id=8f619db8"
import script from "./ruleItem.vue?vue&type=script&lang=js"
export * from "./ruleItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\华水\\hsmanagementsystem\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8f619db8')) {
      api.createRecord('8f619db8', component.options)
    } else {
      api.reload('8f619db8', component.options)
    }
    module.hot.accept("./ruleItem.vue?vue&type=template&id=8f619db8", function () {
      api.rerender('8f619db8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dataprivilegerules/ruleItem.vue"
export default component.exports